import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['select']
  static values = {
    arguments: { default: [], type: Array },
    namespace: { default: 'admin', type: String }
  }

  connect() {
    new TomSelect(this.selectTarget, {
      labelField: 'displayLabel',
      load: (query, callback) => this.search(query, callback),
      preload: false,
      searchField: ['fullName'],
      shouldLoad: query => query.length >= 2,
      valueField: 'id'
    })
  }

  async search(query, callback) {
    const response = await get(
      [
        `/${this.namespaceValue}/drivers?q[search_by_full_name_or_email_or_phone]=${encodeURIComponent(query)}`,
        ...this.argumentsValue
      ].join('&'),
      {
        responseKind: 'json'
      }
    )

    if (response.ok) {
      callback(await response.json)
    } else {
      callback()
    }
  }
}
